export const CHANGE_TYPE_ADD = 'add'
export const CHANGE_TYPE_MODIFY = 'modify'
export const CHANGE_TYPE_MOVE = 'move'
export const CHANGE_TYPE_REMOVE = 'remove'
